var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stars_svg__a)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 45.426,
    height: 45.424,
    x: -8.713,
    y: 7.937
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#stars_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#stars_svg__c)",
    shapeRendering: "crispEdges"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stars_svg__d)",
    fillOpacity: 0.2,
    d: "M12.5 18.055c.463-1.253.695-1.879 1.032-2.057a1 1 0 0 1 .936 0c.337.178.569.805 1.033 2.057l2.025 5.474c.094.253.14.38.216.487q.1.142.242.242c.107.075.233.122.487.216l5.474 2.025c1.253.464 1.879.696 2.057 1.033a1 1 0 0 1 0 .936c-.178.337-.805.569-2.057 1.033l-5.474 2.025c-.253.094-.38.14-.487.216a1 1 0 0 0-.242.242c-.075.107-.122.233-.216.487l-2.025 5.474c-.464 1.252-.696 1.879-1.033 2.057a1 1 0 0 1-.936 0c-.337-.178-.569-.805-1.033-2.057l-2.025-5.474c-.094-.253-.14-.38-.216-.487a1 1 0 0 0-.242-.242c-.107-.075-.233-.122-.487-.216l-5.474-2.025c-1.252-.464-1.879-.696-2.057-1.033a1 1 0 0 1 0-.936c.178-.337.805-.569 2.057-1.033l5.474-2.025c.254-.094.38-.14.487-.216q.142-.1.242-.242c.075-.107.122-.233.216-.487z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#stars_svg__e)",
    d: "M12.5 18.055c.463-1.253.695-1.879 1.032-2.057a1 1 0 0 1 .936 0c.337.178.569.805 1.033 2.057l2.025 5.474c.094.253.14.38.216.487q.1.142.242.242c.107.075.233.122.487.216l5.474 2.025c1.253.464 1.879.696 2.057 1.033a1 1 0 0 1 0 .936c-.178.337-.805.569-2.057 1.033l-5.474 2.025c-.253.094-.38.14-.487.216a1 1 0 0 0-.242.242c-.075.107-.122.233-.216.487l-2.025 5.474c-.464 1.252-.696 1.879-1.033 2.057a1 1 0 0 1-.936 0c-.337-.178-.569-.805-1.033-2.057l-2.025-5.474c-.094-.253-.14-.38-.216-.487a1 1 0 0 0-.242-.242c-.107-.075-.233-.122-.487-.216l-5.474-2.025c-1.252-.464-1.879-.696-2.057-1.033a1 1 0 0 1 0-.936c.178-.337.805-.569 2.057-1.033l5.474-2.025c.254-.094.38-.14.487-.216q.142-.1.242-.242c.075-.107.122-.233.216-.487z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M13.767 16.44a.5.5 0 0 1 .466 0s.026.013.072.076c.049.066.107.168.18.32.146.312.311.757.546 1.393l2.026 5.473c.084.23.155.43.276.602.1.14.222.264.363.363.172.12.373.192.602.276l5.474 2.026c.635.235 1.08.4 1.391.547.154.072.255.13.321.18a.3.3 0 0 1 .076.07.5.5 0 0 1 0 .467s-.013.026-.076.072a2 2 0 0 1-.32.18c-.312.146-.757.311-1.393.546l-5.473 2.026c-.229.084-.43.155-.602.276a1.5 1.5 0 0 0-.363.363c-.12.172-.192.373-.276.602l-2.026 5.474c-.235.635-.4 1.08-.547 1.391a2 2 0 0 1-.18.321.3.3 0 0 1-.07.076.5.5 0 0 1-.467 0s-.026-.013-.072-.076a2 2 0 0 1-.18-.32c-.146-.312-.311-.757-.546-1.392l-2.026-5.474c-.084-.229-.155-.43-.276-.602a1.5 1.5 0 0 0-.363-.363c-.172-.12-.373-.192-.602-.276L4.23 29.03c-.636-.235-1.08-.4-1.392-.547a2 2 0 0 1-.321-.18c-.063-.045-.077-.07-.077-.07a.5.5 0 0 1 0-.467s.014-.026.077-.072c.066-.049.167-.107.32-.18.312-.146.757-.311 1.393-.546l5.473-2.026c.229-.084.43-.155.602-.276a1.5 1.5 0 0 0 .363-.363c.12-.172.192-.373.276-.602l2.026-5.474c.235-.635.4-1.08.547-1.391a2 2 0 0 1 .18-.321.3.3 0 0 1 .07-.076Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 41.426,
    height: 41.424,
    x: 10.287,
    y: -6.063
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#stars_svg__f)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#stars_svg__g)",
    shapeRendering: "crispEdges"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stars_svg__h)",
    fillOpacity: 0.5,
    d: "M29.5 4.055c.463-1.252.695-1.879 1.032-2.057a1 1 0 0 1 .936 0c.337.178.569.805 1.033 2.057l1.485 4.014c.094.254.14.38.215.487a1 1 0 0 0 .243.243c.106.074.233.121.487.215l4.014 1.485c1.252.464 1.879.696 2.057 1.033a1 1 0 0 1 0 .936c-.178.337-.805.569-2.057 1.033l-4.014 1.485c-.254.094-.38.14-.487.215a1 1 0 0 0-.243.243c-.074.106-.121.233-.215.487L32.5 19.945c-.464 1.252-.696 1.879-1.033 2.057a1 1 0 0 1-.936 0c-.337-.178-.569-.805-1.033-2.057l-1.485-4.014c-.094-.254-.14-.38-.215-.487a1 1 0 0 0-.243-.243c-.106-.074-.233-.121-.487-.215L23.055 13.5c-1.252-.464-1.879-.696-2.057-1.033a1 1 0 0 1 0-.936c.178-.337.805-.569 2.057-1.033l4.014-1.485c.254-.094.38-.14.487-.215a1 1 0 0 0 .243-.243c.074-.106.121-.233.215-.487z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#stars_svg__i)",
    fillOpacity: 0.25,
    d: "M29.5 4.055c.463-1.252.695-1.879 1.032-2.057a1 1 0 0 1 .936 0c.337.178.569.805 1.033 2.057l1.485 4.014c.094.254.14.38.215.487a1 1 0 0 0 .243.243c.106.074.233.121.487.215l4.014 1.485c1.252.464 1.879.696 2.057 1.033a1 1 0 0 1 0 .936c-.178.337-.805.569-2.057 1.033l-4.014 1.485c-.254.094-.38.14-.487.215a1 1 0 0 0-.243.243c-.074.106-.121.233-.215.487L32.5 19.945c-.464 1.252-.696 1.879-1.033 2.057a1 1 0 0 1-.936 0c-.337-.178-.569-.805-1.033-2.057l-1.485-4.014c-.094-.254-.14-.38-.215-.487a1 1 0 0 0-.243-.243c-.106-.074-.233-.121-.487-.215L23.055 13.5c-1.252-.464-1.879-.696-2.057-1.033a1 1 0 0 1 0-.936c.178-.337.805-.569 2.057-1.033l4.014-1.485c.254-.094.38-.14.487-.215a1 1 0 0 0 .243-.243c.074-.106.121-.233.215-.487z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M30.767 2.44a.5.5 0 0 1 .466 0s.026.013.072.076c.049.066.107.167.18.32.146.312.311.757.546 1.393l1.486 4.013c.084.229.154.43.275.602q.151.213.364.363c.172.121.373.192.602.276l4.014 1.486c.635.235 1.08.4 1.391.547.154.072.255.13.321.18a.3.3 0 0 1 .076.07.5.5 0 0 1 0 .467s-.013.026-.076.072a2 2 0 0 1-.32.18c-.312.146-.757.311-1.392.546l-4.014 1.486c-.229.084-.43.154-.602.275-.141.1-.265.223-.364.364-.12.172-.19.373-.275.602l-1.486 4.014c-.235.635-.4 1.08-.547 1.391a2 2 0 0 1-.18.321.3.3 0 0 1-.07.076.5.5 0 0 1-.467 0s-.026-.013-.072-.076a2 2 0 0 1-.18-.32c-.146-.312-.311-.757-.546-1.393l-1.486-4.013c-.084-.229-.154-.43-.275-.602a1.5 1.5 0 0 0-.365-.364c-.172-.12-.372-.19-.6-.275l-4.014-1.486c-.636-.235-1.08-.4-1.392-.547a2 2 0 0 1-.321-.18.3.3 0 0 1-.076-.07.5.5 0 0 1 0-.467s.013-.026.076-.072a2 2 0 0 1 .32-.18c.312-.146.757-.311 1.393-.546l4.013-1.486c.229-.084.43-.154.602-.275q.213-.152.363-.365c.12-.172.192-.372.276-.6l1.486-4.014c.235-.636.4-1.08.547-1.392.072-.154.13-.255.18-.321.045-.063.07-.077.07-.077Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 49.426,
    height: 49.424,
    x: 15.287,
    y: 17.936
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#stars_svg__j)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#stars_svg__k)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stars_svg__l)",
    d: "M38.5 28.055c.463-1.252.695-1.879 1.032-2.057a1 1 0 0 1 .936 0c.337.178.569.805 1.033 2.057l2.565 6.934c.094.253.141.38.216.487q.1.142.242.242c.107.075.234.122.487.216l6.934 2.565c1.252.464 1.879.696 2.057 1.033a1 1 0 0 1 0 .936c-.178.337-.805.569-2.057 1.033l-6.934 2.565c-.253.094-.38.141-.487.216a1 1 0 0 0-.242.242c-.075.107-.122.234-.216.487l-2.565 6.934c-.464 1.252-.696 1.879-1.033 2.057a1 1 0 0 1-.936 0c-.337-.178-.569-.805-1.033-2.057l-2.565-6.934c-.094-.253-.141-.38-.216-.487a1 1 0 0 0-.242-.242c-.107-.075-.234-.122-.487-.216l-6.934-2.565c-1.252-.464-1.879-.696-2.057-1.033a1 1 0 0 1 0-.936c.178-.337.805-.569 2.057-1.033l6.934-2.565c.253-.094.38-.141.487-.216q.142-.1.242-.242c.075-.107.122-.234.216-.487z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    d: "M39.767 26.44a.5.5 0 0 1 .466 0s.026.013.072.076c.049.066.107.168.18.32.146.312.311.757.546 1.393l2.567 6.933c.084.229.154.43.275.602.1.14.222.264.363.363.172.12.373.19.602.275l6.934 2.567c.635.235 1.08.4 1.391.547.154.072.255.13.321.18a.3.3 0 0 1 .076.07.5.5 0 0 1 0 .467s-.013.026-.076.072a2 2 0 0 1-.32.18c-.312.146-.757.311-1.392.546l-6.934 2.567c-.229.084-.43.154-.602.275-.14.1-.264.222-.363.363-.12.172-.19.373-.275.602l-2.567 6.934c-.235.635-.4 1.08-.547 1.391a2 2 0 0 1-.18.321.3.3 0 0 1-.07.076.5.5 0 0 1-.467 0s-.026-.013-.072-.076a2 2 0 0 1-.18-.32c-.146-.312-.311-.757-.546-1.392l-2.567-6.934c-.084-.229-.154-.43-.275-.602a1.5 1.5 0 0 0-.363-.363c-.172-.12-.373-.19-.602-.275L28.23 41.03c-.636-.235-1.08-.4-1.392-.547a2 2 0 0 1-.321-.18.3.3 0 0 1-.076-.07.5.5 0 0 1 0-.467s.013-.026.076-.072a2 2 0 0 1 .32-.18c.312-.146.757-.311 1.393-.546l6.933-2.567c.229-.084.43-.154.602-.275.14-.1.264-.222.363-.363.12-.172.19-.373.275-.602l2.567-6.933c.235-.636.4-1.08.547-1.392a2 2 0 0 1 .18-.321.3.3 0 0 1 .07-.076Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__b",
    transform: "translate(8.713 -7.937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.055c.463-1.253.695-1.879 1.032-2.057a1 1 0 0 1 .936 0c.337.178.569.805 1.033 2.057l2.025 5.474c.094.253.14.38.216.487q.1.142.242.242c.107.075.233.122.487.216l5.474 2.025c1.253.464 1.879.696 2.057 1.033a1 1 0 0 1 0 .936c-.178.337-.805.569-2.057 1.033l-5.474 2.025c-.253.094-.38.14-.487.216a1 1 0 0 0-.242.242c-.075.107-.122.233-.216.487l-2.025 5.474c-.464 1.252-.696 1.879-1.033 2.057a1 1 0 0 1-.936 0c-.337-.178-.569-.805-1.033-2.057l-2.025-5.474c-.094-.253-.14-.38-.216-.487a1 1 0 0 0-.242-.242c-.107-.075-.233-.122-.487-.216l-5.474-2.025c-1.252-.464-1.879-.696-2.057-1.033a1 1 0 0 1 0-.936c.178-.337.805-.569 2.057-1.033l5.474-2.025c.254-.094.38-.14.487-.216q.142-.1.242-.242c.075-.107.122-.233.216-.487z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__f",
    transform: "translate(-10.287 6.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 4.055c.463-1.252.695-1.879 1.032-2.057a1 1 0 0 1 .936 0c.337.178.569.805 1.033 2.057l1.485 4.014c.094.254.14.38.215.487a1 1 0 0 0 .243.243c.106.074.233.121.487.215l4.014 1.485c1.252.464 1.879.696 2.057 1.033a1 1 0 0 1 0 .936c-.178.337-.805.569-2.057 1.033l-4.014 1.485c-.254.094-.38.14-.487.215a1 1 0 0 0-.243.243c-.074.106-.121.233-.215.487L32.5 19.945c-.464 1.252-.696 1.879-1.033 2.057a1 1 0 0 1-.936 0c-.337-.178-.569-.805-1.033-2.057l-1.485-4.014c-.094-.254-.14-.38-.215-.487a1 1 0 0 0-.243-.243c-.106-.074-.233-.121-.487-.215L23.055 13.5c-1.252-.464-1.879-.696-2.057-1.033a1 1 0 0 1 0-.936c.178-.337.805-.569 2.057-1.033l4.014-1.485c.254-.094.38-.14.487-.215a1 1 0 0 0 .243-.243c.074-.106.121-.233.215-.487z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__j",
    transform: "translate(-15.287 -17.936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5 28.055c.463-1.252.695-1.879 1.032-2.057a1 1 0 0 1 .936 0c.337.178.569.805 1.033 2.057l2.565 6.934c.094.253.141.38.216.487q.1.142.242.242c.107.075.234.122.487.216l6.934 2.565c1.252.464 1.879.696 2.057 1.033a1 1 0 0 1 0 .936c-.178.337-.805.569-2.057 1.033l-6.934 2.565c-.253.094-.38.141-.487.216a1 1 0 0 0-.242.242c-.075.107-.122.234-.216.487l-2.565 6.934c-.464 1.252-.696 1.879-1.033 2.057a1 1 0 0 1-.936 0c-.337-.178-.569-.805-1.033-2.057l-2.565-6.934c-.094-.253-.141-.38-.216-.487a1 1 0 0 0-.242-.242c-.107-.075-.234-.122-.487-.216l-6.934-2.565c-1.252-.464-1.879-.696-2.057-1.033a1 1 0 0 1 0-.936c.178-.337.805-.569 2.057-1.033l6.934-2.565c.253-.094.38-.141.487-.216q.142-.1.242-.242c.075-.107.122-.234.216-.487z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__d",
    x1: 14,
    x2: 14,
    y1: 26.425,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__h",
    x1: 31,
    x2: 31,
    y1: 10.65,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__l",
    x1: 41.044,
    x2: 41.044,
    y1: 24.428,
    y2: 72.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stars_svg__c",
    width: 45.426,
    height: 45.424,
    x: -8.713,
    y: 7.937,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_6662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_6662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stars_svg__g",
    width: 41.426,
    height: 41.424,
    x: 10.287,
    y: -6.063,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_6662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_6662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stars_svg__k",
    width: 49.426,
    height: 49.424,
    x: 15.287,
    y: 17.936,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_6662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_6662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "stars_svg__e",
    width: 2.286,
    height: 2.286,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stars_svg__m",
    transform: "scale(.00223)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "stars_svg__i",
    width: 2.667,
    height: 2.667,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stars_svg__m",
    transform: "scale(.0026)"
  })))));
};
export default SvgStars;